// extracted by mini-css-extract-plugin
module.exports = {"videoFeature":"style_videoFeature__vAgU2 g-grid-container"};